module.exports = __webpack_public_path__ + "img/Picto_Step_01.a9644f04.png";